<template>
  <d2-container>
    <el-form :model="form" :rules="rules" ref="form" label-width="220px">
      <el-form-item label="是否虚拟" required prop="isVirtual">
        <el-radio-group v-model="form.isVirtual">
          <el-radio :label="1">是</el-radio>
          <el-radio :label="0">否</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="岗位类型" required prop="isVirtual">
        <el-radio-group v-model="form.type">
          <el-radio :label="0">创作类</el-radio>
          <el-radio :label="1">销售类</el-radio>
          <el-radio :label="2">智能体</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="智能体" prop="agentId" v-if="form.type == 2">
        <el-select v-model="form.agentId" placeholder="请选择智能体">
          <el-option v-for="item in agentOptions" :key="item.key" :label="item.value" :value="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="虚拟昵称" prop="virtualNickname" v-if="form.isVirtual == 1">
        <el-input v-model="form.virtualNickname" placeholder="请输入虚拟名称"></el-input>
      </el-form-item>
      <el-form-item label="虚拟头像(最大不能超过2M)" prop="virtualAvatar" v-if="form.isVirtual == 1">
        <uploadImg
          v-model="form.virtualAvatar"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="主题色" prop="textColor">
        <el-color-picker v-model="form.textColor"></el-color-picker>

      </el-form-item>
      <el-form-item label="背景图(最大不能超过2M)" prop="color">
        <uploadImg
          v-model="form.color"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="岗位名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入岗位名称"></el-input>
      </el-form-item>
      <el-form-item label="岗位背景图(最大不能超过2M)" prop="backImg">
        <uploadImg v-model="form.backImg" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="首页图标" prop="homeIcon">
        <uploadImg v-model="form.homeIcon" :imgSize="1" :text="['图片大小500kb以内', '图片格式png/jpg/gif']"></uploadImg>
      </el-form-item>
      <el-form-item label="首页默认图标" prop="defaultHomeIcon">
        <uploadImg
          v-model="form.defaultHomeIcon"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="岗位描述" prop="description">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4 }"
          placeholder="请输入岗位描述"
          v-model="form.description"
        ></el-input>
      </el-form-item>
      <el-form-item label="卡片缩略图(最大不能超过2M)" prop="icon">
         <uploadImg
          v-model="form.icon"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="卡片选择图(最大不能超过2M)" prop="chooseIcon">
        <uploadImg
          v-model="form.chooseIcon"
          :imgSize="1"
          :text="['图片大小500kb以内', '图片格式png/jpg/gif']"
        ></uploadImg>
      </el-form-item>
      <el-form-item label="每人可添加数量" prop="limitCount">
        <el-input v-model="form.limitCount" placeholder="请输入每人可添加数量"></el-input>
      </el-form-item>
      <el-form-item label="跳转地址" prop="routeLink" required>
        <jumpType2 :Jumpurls="form.routeLink"></jumpType2>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button @click="cancel('form')">取 消</el-button>
      <el-button type="primary" @click="getCreate('form')">确 定</el-button>
    </div>
  </d2-container>
</template>

<script>
import { mapGetters } from 'vuex'
import { getToken, getHttps } from '@/api/demo/classification/index'
import { addCert, editCert, certDetail } from '@/api/demo/close/index'
import { agentOptions } from '@/api/merchant/agent'
import uploadImg from '@/components/uploadImage/index.vue'
import jumpType2 from '@/components/jumpType/jumpType.vue'
export default {
  name: 'addCloseCertifi',
  components: {
    jumpType2,
    uploadImg
  },
  data () {
    return {
      agentOptions: [],
      form: {
        type: 0,
        agentId: '',
        virtualAvatar: '', // 虚拟头像
        homeIcon: '',
        defaultHomeIcon: '', // 首页默认图标
        virtualNickname: '',
        backImg: '',
        color: '',
        textColor: '',
        chooseIcon: '',
        description: '',
        isVirtual: 1,
        icon: '',
        name: '',
        paramType: 0,
        paramValue: '',
        skipLink: '',
        limitCount: '',
        openDraw: 0,
        drawId: '',
        drawAnimation: '',
        drawButtonImg: '',
        routeLink: {
          url: null,
          id: null,
          classId: null,
          paramType: '0',
          value: ''
        } // 链接地址
      },
      listQuery: {
        isHot: '',
        keyword: '',
        currentPage: 1,
        pageSize: 20,
        categoryId: ''
      },
      openDrawList: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      rules: {
        agentId: [
          {
            required: true,
            message: '请选择智能体',
            trigger: 'change',
            vaildator: (rule, value, callback) => {
              if (this.form.type == 2 && !value) {
                callback(new Error('请选择智能体'))
              } else {
                callback()
              }
            }
          }
        ],
        virtualNickname: [
          {
            required: true,
            message: '请输入虚拟名称',
            trigger: 'blur'
          },
          {
            min: 1,
            max: 15,
            message: '长度在 1 到 15 个字符',
            trigger: 'blur'
          }
        ],
        virtualAvatar: [
          {
            required: true,
            message: '请上传虚拟头像',
            trigger: 'change'
          }
        ],
        backImg: [
          {
            required: true,
            message: '请上传岗位背景图',
            trigger: 'change'
          }
        ],
        color: [
          {
            required: true,
            message: '请上传背景图',
            trigger: 'change'
          }
        ],
        homeIcon: [
          {
            required: true,
            message: '请上传首页图标',
            trigger: 'change'
          }
        ],
        defaultHomeIcon: [
          {
            required: true,
            message: '请上传首页默认图标',
            trigger: 'change'
          }
        ],
        icon: [
          {
            required: true,
            message: '请上传卡片缩略图',
            trigger: 'change'
          }
        ],
        chooseIcon: [
          {
            required: true,
            message: '请上传卡片选择图',
            trigger: 'change'
          }
        ],
        drawAnimation: [
          {
            required: true,
            message: '请上传抽奖动画',
            trigger: 'change'
          }
        ],
        drawButtonImg: [
          {
            required: true,
            message: '请上传抽奖按钮',
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: '请输入岗位名称',
            trigger: 'blur'
          }
        ],
        drawId: [
          {
            required: true,
            message: '请输入抽奖ID',
            trigger: 'blur'
          }
        ],
        openDraw: [
          {
            required: true,
            message: '请选择是否开启抽奖',
            trigger: 'change'
          }
        ],
        limitCount: [
          {
            required: true,
            message: '请输入每人可添加数量',
            trigger: 'blur'
          }
        ],
        description: [
          {
            required: true,
            message: '请输入岗位描述',
            trigger: 'blur'
          }
        ],
        isVirtual: [
          {
            required: true,
            message: '请选择是否虚拟',
            trigger: 'change'
          }
        ]
      },
      // 七牛上传图片
      uploadData: { key: '', token: '' },

      getId: '',
      listHttps: []
    }
  },
  computed: {
    ...mapGetters(['elements'])
  },
  created () {
    this.getId = this.$route.query.id
    this.getAgentOption()
    if (this.getId) {
      certDetail(this.getId).then(res => {
        this.form.name = res.name
        this.form.description = res.description
        this.form.isVirtual = res.isVirtual
        this.form.virtualNickname = res.virtualNickname
        this.form.virtualAvatar = res.virtualAvatar
        this.form.homeIcon = res.homeIcon
        this.form.defaultHomeIcon = res.defaultHomeIcon
        if (this.form.isVirtual == 0) {
          this.form.virtualNickname = ''
        } else {
        }
        this.form.backImg = res.backImg
        this.form.color = res.color
        this.form.textColor = res.textColor
        this.form.icon = res.icon
        this.form.type = res.type
        this.form.openDraw = res.openDraw
        this.form.drawId = res.drawId
        this.form.agentId = res.agentId
        this.form.drawAnimation = res.drawAnimation
        this.form.drawButtonImg = res.drawButtonImg
        if (res.chooseIcon) {
          this.form.chooseIcon = res.chooseIcon
        }
        this.form.limitCount = res.limitCount
        this.$nextTick(() => {
          getHttps().then(res1 => {
            res1.map((item, index) => {
              if (item.id == res.paramType) {
                this.form.routeLink.id = item.id
                this.form.routeLink.paramType = item.paramType
                this.form.routeLink.name = item.name
                if (this.form.routeLink.id == '6') {
                  this.form.routeLink.value = res.paramValue
                } else {
                  this.form.routeLink.value = Number(res.paramValue)
                }
                console.log(
                  this.form.routeLink.value,
                  'this.form.routeLink.value'
                )
                this.form.routeLink.url = item.url
              }
            })
          })
        })
      })
    } else {

    }
  },
  mounted () {
    let that = this
  },
  methods: {
    getAgentOption () {
      agentOptions().then(res => {
        this.agentOptions = res
      })
    },
    // 新增文章内容
    getCreate (ruleForm) {
      let that = this
      // this.form.id = this.$route.query.id;
      this.form.paramType = this.form.routeLink.id
      if (this.form.routeLink.url == undefined) {
        this.form.skipLink = ''
      } else {
        this.form.skipLink = this.form.routeLink.url
      }
      this.form.paramValue = this.form.routeLink.value
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          if (this.getId == '' || this.getId == undefined) {
            addCert(this.form).then(res => {
              that.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
                duration: 2000
              })
              this.$router.push({
                path: '/demo/close'
              })
            })
          } else {
            if (
              this.form.routeLink.url == '' ||
              this.form.routeLink.url == undefined
            ) {
              this.form.skipLink = ''
            } else {
              this.form.skipLink = this.form.routeLink.url
            }
            editCert(this.getId, this.form).then(res => {
              that.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
                duration: 2000
              })
              this.$router.push({
                path: '/demo/close'
              })
            })
          }
        }
      })
    },
    // 是否开启抽奖
    isDraw (draw) {
      if (draw == 1) {
        this.form.drawId = ''
      }
    },
    // 取消
    cancel () {
      this.$router.push('/demo/close')
    }
  }
}
</script>

<style scoped>
.footer {
  text-align: center;
  margin-top: 30px;
}
.el-dialog__footer {
  display: flex;
}
/deep/ .el-input__inner {
  width: 300px;
}
/deep/ .el-textarea__inner {
  width: 300px;
}
.el-upload__tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  margin-top: 0;
  line-height: 16px;
}
</style>
